import { render, staticRenderFns } from "./DefaultHeaderProfileDropdown.vue?vue&type=template&id=0ccb4b80&"
import script from "./DefaultHeaderProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./DefaultHeaderProfileDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHeaderProfileDropdown.vue?vue&type=style&index=0&id=0ccb4b80&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccb4b80')) {
      api.createRecord('0ccb4b80', component.options)
    } else {
      api.reload('0ccb4b80', component.options)
    }
    module.hot.accept("./DefaultHeaderProfileDropdown.vue?vue&type=template&id=0ccb4b80&", function () {
      api.rerender('0ccb4b80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/DefaultHeaderProfileDropdown.vue"
export default component.exports